import { ErrorMessage } from '@hookform/error-message';
import { Button, Label } from '@repo/shadcn';
import { FormProvider } from 'react-hook-form';
import { PiPlusCircleDuotone } from 'react-icons/pi';

import HeadingWrapper from '@/components/ui/heading/heading-wrapper';
import PageHeading from '@/components/ui/heading/page-headeing';
import SheetWrapper from '@/components/ui/sheet.wrapper/sheet-wrapper';
import { DynamicControl } from '@/shared/dynamic-control';

import { createUserField } from '../user-input';
import { useCreateUser } from './create-user.hook';

export const CreateUser = () => {
    const { fieldOptions, control, handleSubmit, form, isLoading } =
        useCreateUser();

    return (
        <div>
            <div className="srounded-md mt-5 bg-white shadow-sm ">
                <SheetWrapper position="top" className=" mx-auto w-1/2">
                    <HeadingWrapper>
                        <div className="flex items-center justify-between">
                            <PageHeading
                                title="Create New User"
                                subTitle="Create new user with role."
                            />
                        </div>
                    </HeadingWrapper>
                    <form onSubmit={handleSubmit}>
                        <FormProvider {...form}>
                            <div className=" mt-5 grid grid-cols-1 gap-5">
                                {createUserField.map((d, i) => (
                                    <div
                                        key={i}
                                        className={`mt-3  ${d.className}`}
                                    >
                                        <div className=" item-center mb-2 flex h-fit justify-between">
                                            <Label className="h-fit ">
                                                {d.label}
                                            </Label>
                                            {d.actionBtn && (
                                                <Label className="flex cursor-pointer items-center  gap-1 text-primary hover:underline">
                                                    <PiPlusCircleDuotone
                                                        size={16}
                                                        className="-mt-1"
                                                    />{' '}
                                                    {d.actionBtnLabel}
                                                </Label>
                                            )}
                                        </div>
                                        <DynamicControl
                                            {...d}
                                            fieldName={d.fieldName}
                                            options={fieldOptions[d.fieldName]}
                                            control={control}
                                        />
                                        <ErrorMessage
                                            name={d.fieldName}
                                            render={({ message }) => (
                                                <p className="mt-1 text-sm text-red-600">
                                                    {message}
                                                </p>
                                            )}
                                        />
                                    </div>
                                ))}
                            </div>
                        </FormProvider>

                        <Button className="mt-5">
                            {isLoading ? 'Saving...' : 'Save & Submit'}
                        </Button>
                    </form>
                </SheetWrapper>
            </div>
        </div>
    );
};
